import styles from './index.module.less';
import logo from '@/assets/images/main/logo.png'

interface propsType {
  tag: number,
  setTag: any
}

export default function Header (props: propsType) {
  const { tag, setTag } = props
  const tagChange = (id: number) => {
    setTag(id)
  }
  return (
    <div className={styles.header}>
      <img src={logo} alt="" />
      <ul>
        <li onClick={() => tagChange(0)} className={tag === 0 ? styles.on : ''}>官方首页</li>
        <li onClick={() => tagChange(1)} className={tag === 1 ? styles.on : ''}>产品介绍</li>
        <li onClick={() => tagChange(2)} className={tag === 2 ? styles.on : ''}>关于我们</li>
      </ul>
    </div >
  )
}